import { LANDING_FACTS_TIMEOUT_MS } from '~/constants/landing';
import type { FeaturedProjectsPayload } from '~/types/landing';

const LANDING_FEATURED_PROJECTS_KEY = 'landing-featured-projects';
const EMPTY_FEATURED: FeaturedProjectsPayload = { items: [], total: null };

/**
 * Hero default rows, rendered on the server: 4 minimal non-exclusive display rows (no ids/images),
 * so the page payload carries no project objects and the client makes no projects request on load.
 */
export const useLandingFeaturedProjects = () => {
  const { data, pending } = useAsyncData<FeaturedProjectsPayload>(
    LANDING_FEATURED_PROJECTS_KEY,
    async () => {
      const res = await $fetch<{ data?: FeaturedProjectsPayload }>('/api/landing/featured-projects', {
        timeout: LANDING_FACTS_TIMEOUT_MS,
      });
      return res?.data ?? EMPTY_FEATURED;
    },
    { default: () => EMPTY_FEATURED },
  );

  return {
    featuredRows: computed(() => data.value?.items ?? []),
    featuredTotal: computed(() => data.value?.total ?? null),
    featuredPending: pending,
  };
};
